import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { OnsiteInterviewAdapters } from '../adapters';
import { ICreateOnsiteInterviewPayload } from '../types';

export const createOnsiteInterviews = async (
  payload: ICreateOnsiteInterviewPayload,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post<void>(
    `/postings/${payload.jobPostingId}/onsite-interviews`,
    OnsiteInterviewAdapters.toCreateOnsiteInterviewApiRequestBody(payload),
    {
      headers,
    },
  );
};
